var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_vm._v(" ©版权所有.蜜钥匙备婚平台 沪ICP备2023010571号-1 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }